import {
  ClientLegalControllerGetGeneratedDocumentsApiArg,
  ClientLegalControllerGetGeneratedDocumentsApiResponse,
} from '@/app/store/api/restApi';
import { emptyApi } from '@/app/store/api/emptyApi';

export const documentsApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getDocuments: build.query<
      ClientLegalControllerGetGeneratedDocumentsApiResponse,
      ClientLegalControllerGetGeneratedDocumentsApiArg
    >({
      query: () => 'legal/documents',
    }),
  }),
});

export const { useGetDocumentsQuery } = documentsApi;
